module.exports = __webpack_public_path__ + "img/蒙版组 150.47d94b8f.png";